import { useState, useEffect } from 'react';

type PlatformMode = 'full' | 'api_as_service';

interface PlatformModeResponse {
  mode: PlatformMode;
  timestamp: string;
  raw_env_var: string;
}

export const usePlatformMode = (): { mode: PlatformMode; loading: boolean; error: string | null } => {
  const [mode, setMode] = useState<PlatformMode>('full');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPlatformMode = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Get backend URL
        const backendUrl = (window as any).RUNTIME_ENV?.BACKEND_URL ?? process.env.BACKEND_URL ?? 'http://localhost:8000/api/v1';
        
        const response = await fetch(`${backendUrl}/platform-mode`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data: PlatformModeResponse = await response.json();
        setMode(data.mode);
      } catch (error) {
        console.error('Failed to fetch platform mode:', error);
        setError(error instanceof Error ? error.message : 'Unknown error');
        // Fallback to full mode if API fails
        setMode('full');
      } finally {
        setLoading(false);
      }
    };

    fetchPlatformMode();
  }, []);

  return { mode, loading, error };
};
